import type { useClerk } from '@clerk/clerk-react';

type ClerkInstance = ReturnType<typeof useClerk> | null;

let clerkRef: ClerkInstance = null;
let redirectInFlight = false;

/** Registered from `ClerkBootstrap` so HTTP interceptors can trigger Clerk flows without React hooks. */
export function registerClerkForHttp(clerk: ClerkInstance): void {
  clerkRef = clerk;
}

export function getRegisteredClerk(): ClerkInstance {
  return clerkRef;
}

/**
 * Used on 401 from API: send user through Clerk sign-in again.
 *
 * ===== FIX (2026-07-19) — חלק מתיקון "רענון אקראי" =====
 * הפונקציה נקראת מ-utils/axios.ts רק אחרי שניסיון חוזר עם טוקן טרי נכשל גם הוא
 * (ראו התיעוד שם). כאן נוספה הגנה אחרונה: אם Clerk עדיין מדווח על סשן פעיל,
 * ה-401 הוא כמעט בוודאות תקלה זמנית בצד השרת (deploy/restart של backend,
 * clock skew) ולא סשן שפג. redirect במצב כזה היה "מרענן" את כל המערכת למשתמש
 * בלי שום תועלת — ואף עלול להיכנס ללופ (מתחברים בהצלחה → 401 שוב → redirect...).
 * לכן במצב סשן פעיל מוותרים על ה-redirect והבקשה פשוט נכשלת נקודתית.
 * כשהסשן באמת לא פעיל (expired / ended / revoked / לא קיים) — ההתנהגות המקורית
 * נשמרת והמשתמש נשלח להתחברות מחדש.
 */
export async function redirectToClerkSignInFromHttp(): Promise<void> {
  if (redirectInFlight) return;
  redirectInFlight = true;
  try {
    const clerk = clerkRef;
    if (clerk?.session?.status === 'active') {
      console.warn(
        '[auth] 401 מהשרת למרות סשן Clerk פעיל — מדלגים על redirect (כנראה תקלה זמנית בצד השרת)',
      );
      return;
    }
    if (clerk) {
      await clerk.redirectToSignIn({ redirectUrl: typeof window !== 'undefined' ? window.location.href : undefined });
    } else if (typeof window !== 'undefined') {
      window.location.assign('/login');
    }
  } finally {
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        redirectInFlight = false;
      }, 2500);
    } else {
      redirectInFlight = false;
    }
  }
}
